import React from 'react';

import { useForm } from 'react-hook-form';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';

import { LbInput, LbSelect, LbDatePicker } from '@infoods/lifebase-ui';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';

import { challengesListStore } from '../../../stores/challengesListStore';
import { ChallengeListFilterValues } from '../../../interfaces/challenges-list/ChallengeListFilters';
import { useAutoSubmitForm } from '../../../../shared/hooks/useAutoSubmitForm';
import { challengeStatusOptions } from '../../../constants/challengeStatus';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { dateTimeFormatWithTimezone } from '../../../../shared/constants/apiDateFormat';
import { addAllOption } from '../../../../shared/utils/arrayUtils';
import {
  CHALLENGE_CUSTOMER_TYPE,
  challengeCustomerTypeOptions,
} from '../../../constants/challengeCustomerType';
import { solutionsStore } from '../../../../shared/stores/solutionsStore';

const challengeCustomerTypeOptionsWithAll = addAllOption(challengeCustomerTypeOptions);

const FilterRow = observer(() => {
  const { isSuperAdmin, isEntity, isCoach } = loggedInUserDataStore;
  const { solutionTypeFlags } = solutionsStore;
  const { filterMethods } = challengesListStore;
  const { applyFilters } = filterMethods;

  const { control, reset, watch, handleSubmit } = useForm<ChallengeListFilterValues>();

  useAutoSubmitForm(handleSubmit(applyFilters), watch, [
    'challengeName',
    'entityName',
    'startDate',
    'endDate',
  ]);

  const inputGeneralProps = {
    control,
    variant: 'outlined',
    size: 'small',
  } as const;

  const handleReset = () => {
    reset();
  };

  return (
    <GridTableRow
      variant="filter"
      component="form"
      onSubmit={(event) => event.preventDefault()}
    >
      <LbInput {...inputGeneralProps} name="challengeName" placeholder="Name" />
      {isSuperAdmin && (
        <LbInput {...inputGeneralProps} name="entityName" placeholder="Entity" />
      )}
      <LbSelect
        {...inputGeneralProps}
        name="customerType"
        options={challengeCustomerTypeOptionsWithAll}
        displayEmpty
        getOptionDisabled={(option) =>
          option.value === CHALLENGE_CUSTOMER_TYPE.LIFE_BASE_USERS &&
          !solutionTypeFlags.NUTRITION
        }
      />
      <LbDatePicker
        {...inputGeneralProps}
        name="startDate"
        format={dateTimeFormatWithTimezone}
      />
      <LbDatePicker
        {...inputGeneralProps}
        name="endDate"
        format={dateTimeFormatWithTimezone}
      />
      <LbSelect
        {...inputGeneralProps}
        name="challengeStatus"
        options={challengeStatusOptions}
        displayEmpty
      />
      {(isEntity || isCoach) && <div />}
      <GridTableCell justify="end">
        <Button variant="outlined" size="small" type="reset" onClick={handleReset}>
          Clear All
        </Button>
      </GridTableCell>
    </GridTableRow>
  );
});

export { FilterRow };
